import React from "react"
import { withRouter } from "react-router-dom";

class SubHeader extends React.Component {
  constructor(props){
    super(props)

    this.state = {

    }
  }

  componentDidMount(){
    this._updateActive()
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this._updateActive();
    }
  }

  _updateActive() {
    switch(this.props.location.pathname){
      case "/":
        this._setActive("Dashboard")
        break;

      case "/reports":
        this._setActive("Reports")
        break;

      case "/campaigns":
        this._setActive("Campaigns Overview")
        break;

      case "/campaigns/:campaign_slug/edit":
        this._setActive("Campaign")
        break;

      case "/add/campaign":
        this._setActive("Add A Campaign")
        break;

      case "/manage/campaigns":
        this._setActive("Manage Campaigns")
        break;

      case "/agent/overview":
        this._setActive("Agents Overview")
        break;

      case "/agent/applications":
        this._setActive("Applications")
        break;

      case "/agents":
        this._setActive("Manage Agents")
        break;

      case "/add/company":
        this._setActive("Add A Client")
        break;

      case "/companies":
        this._setActive("Manage Clients")
        break;

      case "/phone-numbers":
        this._setActive("Manage Numbers")
        break;

      default:
        // do nothing
        break;
    }
  }

  _setActive(title){
    this.setState({ title })
  }

  render() {
    let { title } = this.state

    return (
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-subheader__main">
          <h3 className="kt-subheader__title">{ title }</h3>
        </div>
        <div className="kt-subheader__toolbar">

        </div>
      </div>
    )
  }
}

export default withRouter(SubHeader);
